    <div class="account-list">
        <span class="account-list__container"
              *ngIf="accounts.length > 0; else loader">
            <div *ngFor="let account of accounts"
                 class="account-list__card"
                 (click)="getDisabledReason(account) ? null : select(account)">
                <div class="account-list__card__avatar">
                    <ik-avatar [avatarUrl]="account.logo"
                               [id]="account.id"
                               [avatarName]="account.name"></ik-avatar>
                </div>
                <div class="account-list__card__info">
                    <span class="account-list__card__name">{{account.name}}</span>
                </div>
                <div class="account-list__card__check"
                     [class.account-list__card__check--disabled]="getDisabledReason(account)"
                     [class.account-list__card__check--checked]="selectedAccount === account"
                     matTooltipClass="custom-tooltip"
                     matTooltip="{{ getDisabledReason(account) || null }}"
                     [matTooltipPosition]="'below'">
                    <div><span class="icon icon-check icon-size-12 white"></span></div>
                </div>
            </div>
        </span>
        <p class="align-center margin-top-30 account-list__change"
           *ngIf="selectedAccount"
           [innerHTML]="changeAccountOrCreateOrgaText">
        </p>
    </div>
    <!-- <div class="steps__actions">
        <button (click)="submit()"
                *ngIf="selectedAccount"
                mat-raised-button
                [class.steps__actions__next--center]="!hasBackButton"
                class="steps__actions__next"
                [buttonLoader]="loading"
                color="primary">
            {{ 'Utiliser cette organisation' | transloco }}
        </button>
    </div> -->
    <ng-template #loader>
        <ik-loader class="center align-center"></ik-loader>
    </ng-template>
